import { Button } from '@humanforce/mango-ui-react';
import type { PayRunNotice } from './payRunNoticeModel';
import { NotImplementedHint } from './PayRunNotImplemented';
import { PayRunInlineCallout } from './PayRunInlineCallout';

interface PayRunNoticeBannerProps {
  notice: PayRunNotice | null;
  /** Invoked by the notice's route out, e.g. "View 3 compliance issues". */
  onAction?: () => void;
}

const TONE: Record<PayRunNotice['tone'], 'caution' | 'positive' | 'info'> = {
  caution: 'caution',
  positive: 'positive',
  info: 'info',
};

/**
 * The PRR-402 "needs your review" banner. The design renders this as a full-width notice above the
 * timeline rather than a titled section, and its copy and tone change with the lifecycle state.
 */
export const PayRunNoticeBanner = ({ notice, onAction }: PayRunNoticeBannerProps) => {
  if (!notice) return null;

  return (
    <PayRunInlineCallout
      tone={TONE[notice.tone]}
      testId="pay-run-notice-banner"
      title={notice.title}
      body={notice.body ? `- ${notice.body}` : undefined}
      adornment={notice.designOnly
        ? (
          <NotImplementedHint
            what="The send-back-for-amendment flow"
            because="A rejection cancels the run permanently, so the design's recoverable state cannot be reached."
            testId="pay-run-notice-hint"
          />
        )
        : undefined}
      action={notice.actionLabel
        ? (
          <Button
            label={notice.actionLabel}
            variant="secondary"
            size="small"
            testId="pay-run-notice-action"
            onClick={onAction}
          />
        )
        : undefined}
    />
  );
};
